import{
    // apiRequest,
    pejabatPenetapDetail,
    pejabatPenetapUpdate,
    employeeList,
    polaKerjaList
} from "../../../../../services/adapters/kepegawaian/pejabatPenetapService"
import{
    apiRequest,
    provinsiDetail,
    provinsiUpdate,
} from "../../../../../services/adapters/master/provinsiService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", provinsiDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", provinsiUpdate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }
    fetchPolaKerja = async (query) => {
        return await apiRequest("get", polaKerjaList, {
            params: query
        }, true)
    }
}

export default UpdateRepository